import React, { useState } from "react";
import { REAngleLeft, REAngleRight, REAnglesLeft } from "./icons/IconSvg";

export default function CommonPagination({ currentPage, pageSize, totalPages, tableCallBack }) {
    const [startPage, setStartPage] = useState(Math.max(currentPage - 3, 1));
    const [endPage, setEndPage] = useState(Math.min(startPage + 6, totalPages));
    const handleNext = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const nextPage = currentPage + 1;
        if (nextPage <= totalPages) {
            tableCallBack(nextPage);
            if (nextPage > endPage) {
                setStartPage(startPage + 1);
                setEndPage(endPage + 1);
            }
        }
    };

    const handlePrevious = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const prevPage = currentPage - 1;
        if (prevPage >= 1) {
            tableCallBack(prevPage);
            if (prevPage < startPage) {
                setStartPage(startPage - 1);
                setEndPage(endPage - 1);
            }
        }
    };
    return (
        <>
            {totalPages > 1 ? (
                <div className="pagination-sec">
                    <div className="container">
                        <div className="pagination-inner">
                            <ul className="pagination-wrapper">
                                {currentPage !== 1 && (
                                    <>
                                        <li>
                                            <button
                                                type="button"
                                                disabled={currentPage === 1}
                                                onClick={() => {
                                                    document.documentElement.scrollTop = 0;
                                                    document.body.scrollTop = 0;
                                                    tableCallBack(1);
                                                }}
                                            >
                                                <REAnglesLeft />
                                            </button>
                                        </li>
                                        <li>
                                            <button type="button" disabled={currentPage === 1} onClick={handlePrevious}>
                                                <REAngleLeft />
                                            </button>
                                        </li>
                                    </>
                                )}
                                {/* {totalPages > 1 &&
                            [...Array(totalPages)].map((_, index) => (
                                <li key={index}>
                                    <button type="button" className={currentPage === index + 1 ? "active" : ""} onClick={() => tableCallBack(index + 1)}>
                                        {index + 1}
                                    </button>
                                </li>
                            ))} */}
                                {totalPages > 1 &&
                                    [...Array(totalPages)].map((_, index) => {
                                        const page = index + 1;
                                        if (page >= startPage && page <= endPage) {
                                            return (
                                                <li key={index}>
                                                    {/* <Link to={buildUrl(page)} className={currentPage === page ? "active" : ""} onClick={() => tableCallBack(page)}>
                                                {page}
                                            </Link> */}
                                                    <button
                                                        type="button"
                                                        className={currentPage === page ? "active" : ""}
                                                        onClick={() => {
                                                            document.documentElement.scrollTop = 0;
                                                            document.body.scrollTop = 0;
                                                            tableCallBack(page);
                                                        }}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            );
                                        }
                                        return null;
                                    })}
                                {currentPage !== totalPages && (
                                    <li>
                                        <button type="button" disabled={currentPage === totalPages} onClick={handleNext}>
                                            <REAngleRight />
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
